'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDoc$002dSigner from "./presto.types$-Doc-Signer.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DocSigner$$anon$131(_$ordinal$34, \u03b4name$34, outer) {
  this.cyb = 0;
  this.a9F = null;
  this.cyb = _$ordinal$34;
  this.a9F = \u03b4name$34;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DocSigner$$anon$131 as $c_Lpresto_types$DocSigner$$anon$131 };
$p = $c_Lpresto_types$DocSigner$$anon$131.prototype = new $j_presto$002etypes$0024$002dDoc$002dSigner.$h_Lpresto_types$DocSigner();
$p.constructor = $c_Lpresto_types$DocSigner$$anon$131;
/** @constructor */
function $h_Lpresto_types$DocSigner$$anon$131() {
}
export { $h_Lpresto_types$DocSigner$$anon$131 as $h_Lpresto_types$DocSigner$$anon$131 };
$h_Lpresto_types$DocSigner$$anon$131.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a9F;
});
$p.l = (function() {
  return this.a9F;
});
var $d_Lpresto_types$DocSigner$$anon$131 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DocSigner$$anon$131, "presto.types$DocSigner$$anon$131", ({
  ZI: 1,
  jQ: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$DocSigner$$anon$131 as $d_Lpresto_types$DocSigner$$anon$131 };
//# sourceMappingURL=presto.types$-Doc-Signer$$anon$131.js.map
